import useApi from '../../../services/useApi'

export const useGetSalesRepDropdown = (): any => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery(
    `/analytics/profitability/filters/customer-reps`
  )

  return {
    salesReps: response?.data || [],
    isLoading: isFetching,
  }
}
